var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillScreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12028_22360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 5.83203L10.0007 9.9987L5.83398 14.1654M14.1673 5.83203H11.0423M14.1673 5.83203V8.95703M5.83398 14.1654H8.95898M5.83398 14.1654V11.0404",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 9.99935C1.66699 6.07102 1.66699 4.10685 2.88699 2.88602C4.10866 1.66602 6.07199 1.66602 10.0003 1.66602C13.9287 1.66602 15.8928 1.66602 17.1128 2.88602C18.3337 4.10768 18.3337 6.07102 18.3337 9.99935C18.3337 13.9277 18.3337 15.8918 17.1128 17.1118C15.8937 18.3327 13.9287 18.3327 10.0003 18.3327C6.07199 18.3327 4.10783 18.3327 2.88699 17.1118C1.66699 15.8927 1.66699 13.9277 1.66699 9.99935Z",
    stroke: "#666666",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12028_22360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillScreenIcon);
export default __webpack_public_path__ + "static/media/fill-screen-icon.e5d0b227e04f182d6c2c04ee6177b841.svg";
export { ForwardRef as ReactComponent };